export default __webpack_public_path__ + "static/media/hiteach_logo.8e0fefa4.png";